export const VERSION = "v4.72.0";
